import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Renters Insurance by National Student Services, Inc. (NSSI)", -1)
const _hoisted_2 = {
  width: "100%",
  height: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_3 = { height: "100" }
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = { height: "80%" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "mobile-steps" }
const _hoisted_8 = { height: "80" }
const _hoisted_9 = {
  class: "quote-footer",
  style: {"text-align":"center"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.nssi.com/terms-of-use",
  target: "_blank"
}, " Terms of Use ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.nssi.com/privacy-policy",
  target: "_blank"
}, " Privacy Policy ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logged_in_bar = _resolveComponent("logged-in-bar")!
  const _component_my_logo = _resolveComponent("my-logo")!
  const _component_quote_cart_mobile = _resolveComponent("quote-cart-mobile")!
  const _component_button_step_menu = _resolveComponent("button-step-menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_logged_in_bar),
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_my_logo)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_5, [
            (_ctx.toShowMobileCart())
              ? (_openBlock(), _createBlock(_component_quote_cart_mobile, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.toShowMenuSteps())
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", {
                      class: "mobile-current-step-w-toggle",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMobileStepMenu && _ctx.openMobileStepMenu(...args)))
                    }, [
                      _createTextVNode(" Step: "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.wizardTitle), 1)
                    ])
                  ]),
                  (_ctx.showStepMenu)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["quotesteps", { show: _ctx.toShowMobileStepMenu }])
                      }, [
                        _createElementVNode("span", {
                          class: "close",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMobileStepMenu && _ctx.closeMobileStepMenu(...args)))
                        }, "X"),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuQuoteSteps, (step) => {
                          return (_openBlock(), _createBlock(_component_button_step_menu, {
                            key: step,
                            step: step,
                            onClick: _ctx.closeMobileStepMenu
                          }, null, 8, ["step", "onClick"]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wizardComponent), { anchor: _ctx.anchor }, null, 8, ["anchor"]))
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(" © " + _toDisplayString(_ctx.getCurrentYear) + " National Student Services, Inc. All Rights Reserved. ", 1),
              _hoisted_10,
              _hoisted_11,
              _createTextVNode("  |  "),
              _hoisted_12,
              _createTextVNode("  |  "),
              _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Assurant Legal ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}